import { useQuery } from '@tanstack/react-query';
import { getAllowedUsers, DEFAULT_PER_PAGE } from '../services/IpAssistantService';
import { ipAssistantKeys } from './queryKeys';
export function useAllowedUsers(page, sort) {
    const sortBy = sort ? sort.sortBy : undefined;
    const sortDir = sort ? sort.sortDirection : undefined;
    return useQuery({
        queryKey: ipAssistantKeys.allowedUsers(page, sortBy, sortDir),
        queryFn: () => getAllowedUsers(page, DEFAULT_PER_PAGE, sort),
        staleTime: 2 * 60 * 1000,
        retry: 3,
        keepPreviousData: true
    });
}
